export const UPLOAD_SESSION_ID = 'upload_session_id'

export enum AcceptedFileTypes {
  Images = 'image/*',
  Videos = 'video/*',
}

export const ONE_MEGABYTE_IN_BYTES = 1024 * 1024
export const MAXIMUM_FILE_SIZE_MB = 9
export const MAXIMUM_FILE_SIZE_BYTES = MAXIMUM_FILE_SIZE_MB * ONE_MEGABYTE_IN_BYTES
export const MAXIMUM_FILE_SIZE_TEXT = `${MAXIMUM_FILE_SIZE_MB}MB`
export const MAXIMUM_PHOTO_WIDTH = 1600
export const MAXIMUM_PHOTO_HEIGHT = 1600
export const RESIZED_PHOTO_QUALITY = 0.95
